import { Plugins } from '@leverege/plugin';
import OpenApiItemEditor from "./OpenApiItemEditor.js";
const f = Plugins.createFactory('OpenApiItemEditor', {
  strategy: Plugins.LOOKUP,
  pluginKey: 'editor',
  defaultObject: OpenApiItemEditor
});

// eslint-disable-next-line import/prefer-default-export
export const OpenApiItemEditorFactory = {
  create(item) {
    const model = item?.blueprint?.model;
    const type = model?.['x-lev-object-type'] || model?.type;
    return f.create(type);
  }
};